import { styled } from 'styled-components';

import { mq, colMiddle } from '@/shared/ui/styled';

export const Wrapper = styled.section`
    width: 100%;
    background: linear-gradient(107.41deg, #5e42ce 13.31%, #6bc0fd 100%);
    padding: 24px;

    & > div {
        & > nav {
            .ant-breadcrumb-link {
                color: ${({ theme }) => theme.color.secondary};

                a {
                    color: ${({ theme }) => theme.color.secondary};
                    font-size: 16px;
                }
            }

            ol {
                li:not(:nth-last-child(2)) {
                    & .ant-breadcrumb-link a:hover {
                        color: ${({ theme }) => theme.color.primary} !important;
                    }
                }

                li:nth-last-child(2) {
                    & .ant-breadcrumb-link {
                        color: ${({ theme }) => theme.color.secondary} !important;
                    }
                }
            }
        }
    }

    ${mq.lt.md} {
        & > div > nav {
            display: none;
        }

        padding: 32px 12px;
    }
`;

export const HowWorkServiceBannerContainer = styled.section`
    display: flex;
    min-height: 600px;

    ${mq.lt.md} {
        min-height: 200px;
    }
`;

export const HowWorkServiceBannerLeft = styled.div`
    ${colMiddle};
    flex: 0 0 43%;

    ${mq.lt.lg} {
        flex: 1 1 60%;
    }
`;

export const HowWorkServiceBannerLeftText = styled.p`
    background: ${({ theme }) => theme.color.secondary};
    box-shadow: 0 4px 12px rgb(0 0 0 / 16%);
    border-radius: 16px;
    font-weight: 700;
    padding: 24px;
    margin-bottom: 16px;
    text-align: center;

    span {
        position: absolute;
        display: block;
        width: 80px;
        height: 85px;
        right: -35px;
        top: -40px;
        transform: rotate(-20deg);
    }

    &:first-child {
        max-width: 400px;
        align-items: flex-end;
    }

    &:nth-child(2) {
        max-width: 438px;
        margin-left: auto;
        position: relative;
    }

    &:nth-child(3) {
        max-width: 321px;
        position: relative;

        span {
            display: none;
        }
    }

    &:last-child {
        margin-bottom: 0;
        max-width: 397px;
        margin-left: auto;
    }

    ${mq.lt.md} {
        font-size: ${({ theme }) => theme.fontSize.xs};

        span {
            width: 50px;
            height: 55px;
            right: -30px;
            top: 10px;
        }

        &:nth-child(2) {
            span {
                display: none;
            }
        }

        &:nth-child(3) {
            span {
                display: block;
            }
        }
    }
    ${mq.lt.sm} {
        max-width: 220px !important;
        padding: 12px;

        span {
            top: 0;
        }
    }
`;

export const HowWorkServiceBannerRight = styled.div`
    position: relative;
    flex: 1 1 57%;

    & > span {
        display: block;
        position: absolute;

        &:first-child {
            transform: rotate(-15deg);
            width: 311px;
            height: 311px;
            top: 0;
            left: 120px;
        }

        &:nth-child(2) {
            transform: rotate(20deg);
            width: 126px;
            height: 307px;
            right: 0;
            bottom: 60px;
        }

        &:nth-child(3) {
            width: 138px;
            height: 138px;
            left: 150px;
            bottom: 10px;
        }
    }

    ${mq.lt.lg} {
        flex: 1 1 40%;

        & > span {
            display: block;
            position: absolute;

            &:first-child {
                width: 230px;
                height: 230px;
                top: 0;
                left: 50px;
            }

            &:nth-child(2) {
                width: 100px;
                height: 230px;
                right: 0;
                bottom: 170px;
            }

            &:nth-child(3) {
                width: 138px;
                height: 138px;
                left: 50px;
                bottom: 10px;
            }
        }
    }
    ${mq.lt.md} {
        display: none;
    }
`;
